import { render, staticRenderFns } from "./CommentField.vue?vue&type=template&id=76179eed&scoped=true"
import script from "./CommentField.vue?vue&type=script&lang=js"
export * from "./CommentField.vue?vue&type=script&lang=js"
import style0 from "./CommentField.vue?vue&type=style&index=0&id=76179eed&prod&lang=scss"
import style1 from "./CommentField.vue?vue&type=style&index=1&id=76179eed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76179eed",
  null
  
)

export default component.exports